import React, { Component } from 'react'
import { NavBar, Icon } from 'antd-mobile'
import NavBarComponent from '../../component/common/NavBarComponent'
import './index.scss'
class Webview extends Component {
  constructor(props) {
    super(props);
    this.info = this.props.history.location.query || {}
    this.state = {
      iFrameHeight: '0px'
    }
    // window.location.replace(this.info.url)
  }

  render() {
    return (
        <div id='webview' className="page iframe-wrapper">
            <NavBar 
              className="iframe-nav-bar"
              icon={<Icon type="left" color='#333' />} 
              onLeftClick={() => {this.props.history.goBack()}}
              mode='light'>
              {this.info.title || ''}
            </NavBar>
            <iframe
              id='iframe-body'
              style={{width:'100%', overflow:'visible',height: 'calc(100vh - 45px)'}}
              title='webview'
              onLoad={() => {
                // const obj = ReactDOM.findDOMNode(this.refs.iframe);
                // console.log(obj.contentWindow)
                // this.setState({
                //     "iFrameHeight":  obj.contentWindow.document.body.scrollHeight + 'px'
                // });
              }} 
              ref="iframe" 
              frameBorder="0"
              src= {this.info.url || ''} />
      </div>  
    )
  }
}

export default Webview